module.exports = __webpack_public_path__ + "media/images/press_kit/azamara/main-fe420d0572c603312539a7513e8f178a.png";